<template>
    <section v-if="hasPermissions(['Building Read','Building Write', 'Building Building-Upload' ])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of all Buildings within your Facility. Click "Add Building" to create a new Building. Clicking "Mass Delete" will delete The Building and all Levels, Areas and Rooms within the Building
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="buildings.length">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <UploadOptions
                    :ref="'file_excel'"
                    :empty_format_data="empty_format_data"
                    :excel_file_headers="excel_file_headers"
                    :file_name="'building_template_file'"
                    @data="upload($event)"
                    v-if="hasPermissions(['Building Building-Upload'])"
                />
                <button v-if="hasPermissions(['Building Write'])" class="modal__buttons__item btn-width-4" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>

            <div  v-if="hasPermissions(['Building Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>
        
        <div class="tab-content" v-show="buildings.length && hasPermissions(['Building Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="buildings"
                                :search="search"
                                :checkable="true"
                                :link="'/building/'"
                                :historiable="true"
                                @history="history($event)"
                                @emitAction="emitAction($event)"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                                :array_options_table="array_options_table"
                                ref="dinamic_table"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Building'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Building Update'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>
        
        <HistoryModal
            :histories="histories"
            :title="history_title"
            :breadcrumb="breadcrumb"
        />

        <UploadSummary
            :breadcrumb="breadcrumb"
            :summary="summary"
            :excel_file_headers="excel_file_headers"
            :excel_data="excel_data"
            :file_name="'buildings_falied_template_file'"
        />
        <HelperModal :helps="helps"/>

    </section>

    <section  class="view" v-else>
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            you do not have permission for this section. contact your system administrator
        </h1>
    </section>

</template>

<script>
import _                        from    "underscore"
import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import HelperModal          from    '@/components/HelperModal'
import Resources            from    './resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import DeletionModal        from    '@/components/DeletionModal'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import HistoryModal         from    '@/components/HistoryModal'
import DinamicTable         from    '@/components/DinamicTable'
import UploadOptions        from    '@/components/UploadOptions'
import UploadSummary        from    '@/components/UploadSummary'
// import InstructionModal     from    '@/components/InstructionModal'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
})

export default {

    name: "Building",

    components: {
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        FormModal,
        UpdateModal,
        HistoryModal,
        DinamicTable,
        DeletionMassiveModal,
        UploadOptions,
        UploadSummary,
        HelperModal,
        // InstructionModal
    },

    data() {
        return {
            notyf,
            axios,
            user:                 this.get_user(),
            title_page:           'Buildings',
            content_header:       this.$store.state.headers,
            rest_api:             `buildings`,
            notifications:        this.$store.state.form_notyf,
            table_headers:        Resources.table_headers,
            breadcrumb:           Resources.breadcrumb,
            add_btn:              'Add Building',
            single_select:        false,
            table_selection:      [],
            search:               '',
            global_index:         null,
            single_object:        {},
            buildings:            [],
            array_options:        {},
            excel_file_headers:   Resources.excel_file_headers,
            empty_format_data:    Resources.empty_format_data,
            table_selection_test: [],
            table_headers_test:   Resources.table_headers_test,
            single_select_test:   {},
            search_test:          '',
            histories:            [],
            history_title:        '',
            select_ids:           [],
            summary:              [],
            excel_data:           [],
            totals:               [],
            helps:                Resources.helps
        };
    },

    methods: {
    
        unshift_object(new_object)
        {
            if(this.hasPermissions(['Building Read']))
            {
                this.buildings.unshift(new_object)
            }
        },

        splice_object(splicing_object)
        {
            this.buildings.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            if(!this.user.has_facility){
                notyf.error('There is not exists a facility yet')
                return false
            }
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.buildings[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = {...this.buildings[index]}
            window.$('#static-update').modal('show')
        },

        emitAction(data)
        {
            if(data.header == 'room_counter_record')
            {
                const id = this.$refs.dinamic_table.display_items[data.index].decrypted_id || null;
                this.$router.push(`/building-rooms?building_id=${id}`)
            }
        },

        fill_data(data)
        {
            
            this.buildings = data.buildings

            this.array_options = {
                facility_id: data.facilities
            }
            this.array_options_table = [
                {
                    text: 'Total Sq. Footage',
                    value:0
                }
            ]
            
            this.sumSqFootage()
        },

        trashing(index)
        {
            this.buildings.splice(index, 1)
        },

        async history(id, title)
        {
            if(title === undefined)
            {
                title = id.title
                id = id.id
            }
            const http_request = {
                id,
                history_request: true,
            }
            this.loader(true)
            const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`)

            if(response.status)
            {
                this.history_title = title
                this.histories = response.data.histories
                if(this.histories.length === 0)
                {
                    return this.notyf.error('Empty History')
                }
                setTimeout(()=>{
                    window.$('#static-history').modal('show')
                }, 500)
                this.loader()
            }
            else
            {
                this.error_handling(response)
                this.loader()
            }  
        },

        massive_modal_delete()
        {
            this.select_ids = this.buildings.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids: this.select_ids,
            }

            let sendingMassive = await this.massive_delete(json_request)

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.buildings.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.buildings.splice(index, 1)
                    }
                })
                this.select_ids = []
                this.sumSqFootage()
            }
        },

        async upload(data)
        {
            const send_data = []
            this.excel_data = []

            for ( const value of data) {
                const entity = {}
                for (const prop in this.excel_file_headers) {
                    entity[this.excel_file_headers[prop]] = this.parse_boolean(value[prop])
                }
                this.excel_data.push({... entity})
                send_data.push(entity)
            }

            this.loader(true)
            const response = await this.post(`${this.rest_api}/massive`, { buildings: send_data })
            this.loader()
            
            if(response.status)
            {
                notyf.success('Success!')
                this.summary = response.data.summary
                window.$('#upload-summary').modal('show')
                for (const building of response.data.buildings) {
                    this.unshift_object(building);
                }
            }
            else
            {
                this.error_handling(response)
            }
            this.$refs.file_excel.clear_data()
        },

        async sumSqFootage (list_to_sum)
        {
            list_to_sum = (!list_to_sum) ? this.buildings : list_to_sum

            let sum = 0;
            list_to_sum.forEach(x=>
            {
                const sqFootage = parseFloat(x.sq_footage.replace(/,/g, ''));
    
                if (!isNaN(sqFootage) && sqFootage > 0) {
                    sum += sqFootage;
                }
                
            })
            
            const formattedSum = sum.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 })

            const total_sq = { 'sq_footage':
                {
                    'type': '',
                    'text': 'Sq. Footage',
                    'value': formattedSum,
                    'show' : true,
                },
            }

            this.totals = []

            this.totals.push(total_sq)
            
            this.array_options_table[0].value = formattedSum;

        }
        
    },

    async mounted()
    {
        if(this.hasPermissions(['Building Read']))
        {
            await this.api_request()
        }
    },

    watch:{
        search(val) 
        {
             let filters_items = [];
            if(this.search)
            {
                this.table_headers.forEach(header =>
                { 

                    filters_items.push( ... this.buildings.filter(item =>
                    {
                        return String(item[header.value]).toLowerCase().includes(val.toLowerCase())
                    }))
                });
                const unique_values =  this.search ? _.uniq(filters_items, item => item.id ) : this.items; 

                this.sumSqFootage(unique_values)
            }
            else
            {
                this.sumSqFootage()

            }

        }

    },
    
    computed:
    {
        selected()
        {
            const bool = this.buildings.filter(item => item.checked)
            return Boolean(bool.length)
        },

        // sum_sq_ft()
        // {
        //     const filters_items = [];
        //     if (this.search) {
        //         this.table_headers.forEach(header => {
        //             filters_items.push(...this.buildings.filter(item => {
        //                 return String(item[header.value]).toLowerCase().includes(this.search.toLowerCase());
        //             }));
        //         });
        //     }

        //     const uniqueFiltersItems = _.uniq(filters_items, item => item.id);

        //     const filteredSqFootageSum = uniqueFiltersItems.reduce((sum, item) => {
        //         const sqFootage = parseFloat(item.sq_footage.replace(/,/g, '')) || 0;
        //         return sum + sqFootage;
        //     }, 0);

        //     console.log(uniqueFiltersItems)

        //     return filteredSqFootageSum
        // }
    }

}
</script>
 